import { connect, type MapStateToProps, type MapDispatchToProps } from 'react-redux';
import { fetchPersonalizationSiteTraits } from '../../state/actions/personalization-site-traits';
import { showXflowDialogError, checkProductsLicenceState } from '../../state/actions';
import GetConfluenceViewProvider from './index';
import { type StateProps, type DispatchProps, type OwnProps } from './types';
import { type State } from '../../state/types';
import { getActivationMethod } from '../../state/activation/selectors';
import { startConfluenceActivation } from '../../state/actions/activate-confluence';

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => ({
	activationMethod: getActivationMethod(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch) => ({
	onOpenCrossFlowError: () => dispatch(showXflowDialogError()),
	onSuccessfulCrossFlowExpansion: () => {
		dispatch(checkProductsLicenceState());
		dispatch(fetchPersonalizationSiteTraits());
	},
	triggerOnDemandActivation: () => {
		dispatch(startConfluenceActivation());
	},
});

export default connect<StateProps, DispatchProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps,
)(GetConfluenceViewProvider);
